
import { IContainer } from '../interface/container';
import { bindKVStorage, bindBrowser, bindCache, bindCacheController, bindTranslationStorage, IZip, IFetcher, IKVStorage, IBrowser, ITranslationStorage, injectENV } from '../interface/util';

import { bindENV, bindFetch, bindLog, bindQueryURL, bindZip } from '../interface/util';

/* static-imports, no code-splitting */
import cache from './cache';
import cacheController from './cachecontroller';
import env from './env';
import log from './log';
import query from './querystring';


function _bindENV(container: IContainer) {
    bindENV(env, container);
}

function _bindFetch(container: IContainer) {
    let val: IFetcher|null = null;

    const resolver = () => {
        return new Promise<IFetcher>(async function(resolve, reject) {
            let rejection = null;

            try {
                if ( !val ) {
                    val = (await import('./fetch')).default;
                }
            } catch (error) {
                rejection = error;
            }

            if ( val ) { resolve(val); }
            else { console.error('Fetch failed'); reject(rejection || 'Import failed for fetcher'); }
        });
    }

    bindFetch(resolver, container);
}

function _bindLog(container: IContainer ) {
    bindLog(log(), container);
}

function _bindQueryString(container: IContainer ) {
    bindQueryURL(query, container);
}

function _bindZip(container: IContainer) {
    let val: IZip|null = null;

    const resolver = () => {
        return new Promise<IZip>(async function(resolve, reject) {
            let rejection = null;

            try {
                if ( !val ) {
                    val = (await import('./zip')).default;
                }
            } catch (error) {
                rejection = error;
            }

            if ( val ) { resolve(val); }
            else { reject(rejection || 'Import failed for zip'); }
        });
    }

    bindZip(resolver, container);
}

function _bindKVStorage(container: IContainer) {
    let val: IKVStorage|null = null;

    const resolver = () => {
        return new Promise<IKVStorage>(async function(resolve, reject) {
            let rejection = null;

            try {
                if ( !val ) {
                    val = (await import('./kvstorage')).default();
                }
            } catch (error) {
                rejection = error;
            }

            if ( val ) { resolve(val); }
            else { reject(rejection || 'Import failed for kvstorage'); }
        });
    }

    bindKVStorage(resolver, container);
}

function _bindBrowser(container: IContainer) {
    let val: IBrowser|null = null

    const resolver = () => {
        return new Promise<IBrowser>(async function(resolve, reject) {
            let rejection = null;

            try {
                if ( !val ) {
                    val = (await import('./browser')).default();
                }
            } catch (error) {
                rejection = error;
            }

            if ( val ) { resolve(val); }
            else { reject(rejection || 'Import failed for browser'); }
        });
    }

    bindBrowser(resolver, container);
}

function _bindCache(container: IContainer) {
    bindCache(cache(), container);
}

function _bindCacheController(container: IContainer) {
    bindCacheController(cacheController(), container);
}

function _bindTranslationStorage(container: IContainer) {
    let val: ITranslationStorage|null = null

    const resolver = () => {
        return new Promise<ITranslationStorage>(async function(resolve, reject) {
            let rejection = null;

            try {
                if ( !val ) {
                    const envLoad = injectENV(container);
                    val = (await import('./translationstorage')).default(envLoad);
                    }
            } catch (error) {
                rejection = error;
            }

            if ( val ) { resolve(val); }
            else { reject(rejection || 'Import failed for translation-storage'); }
        });
    }

    bindTranslationStorage(resolver, container);    
}

export function bind(container: IContainer): Promise<void> {
    return new Promise(async function(resolve, reject) {
        try {
            const binders = [_bindENV, _bindFetch, _bindLog, _bindQueryString, _bindZip, _bindKVStorage, _bindBrowser, _bindCache, _bindCacheController, _bindTranslationStorage];

            for ( const binder of binders ) {
                binder.call(null, container);
            }

            resolve();
        } catch (error) {
            reject(error || 'Unknown error binding utils');
        }
    })
}
